// extracted by mini-css-extract-plugin
export default {"evt-slick-prev":"Arrow_evt-slick-prev__4JSxN","evt-slick-next":"Arrow_evt-slick-next__Gs-Wn"};